package com.essntl.uikit.components.scroll

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.foundation.lazy.grid.LazyGridState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier

@Composable
fun EsHorizontalScrollbar(
    scrollState: ScrollState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) = EsHorizontalScrollbarPlatform(
    scrollState = scrollState,
    modifier = modifier,
    reverseLayout = reverseLayout,
    interactionSource = interactionSource
)

@Composable
fun EsHorizontalScrollbar(
    lazyListState: LazyListState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) = EsHorizontalScrollbarPlatform(
    lazyListState = lazyListState,
    modifier = modifier,
    reverseLayout = reverseLayout,
    interactionSource = interactionSource
)

@Composable
fun EsHorizontalScrollbar(
    lazyGridState: LazyGridState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) = EsHorizontalScrollbarPlatform(
    lazyGridState = lazyGridState,
    modifier = modifier,
    reverseLayout = reverseLayout,
    interactionSource = interactionSource
)

@Composable
internal expect fun EsHorizontalScrollbarPlatform(
    scrollState: ScrollState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
)

@Composable
internal expect fun EsHorizontalScrollbarPlatform(
    lazyListState: LazyListState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
)

@Composable
internal expect fun EsHorizontalScrollbarPlatform(
    lazyGridState: LazyGridState,
    modifier: Modifier = Modifier,
    reverseLayout: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
)